// extracted by mini-css-extract-plugin
module.exports = {"root":"MajorMinorFilter_root__34xds","active":"MajorMinorFilter_active__uAu6O"};